import { render } from "./DashboardBilledReserved.vue?vue&type=template&id=2f2d22b1&scoped=true&ts=true"
import script from "./DashboardBilledReserved.vue?vue&type=script&lang=ts"
export * from "./DashboardBilledReserved.vue?vue&type=script&lang=ts"

import "./DashboardBilledReserved.vue?vue&type=style&index=0&id=2f2d22b1&lang=scss&scoped=true"

import exportComponent from "/home/node/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f2d22b1"]])

export default __exports__